import React, { Component } from 'react';
import TwoColumnTable from '../TwoColumnTable';
import ContentOutline from '../ContentOutline';
import TextBlock from '../TextBlock';

import sharedStyles from '../sharedStyles.scss';

const EXAM_SUMMARY = [
  {
    topic: 'Economics and Business Information',
    description:
      'Handling economic cycles, financial reporting, and types of risk. Topics include monetary and fiscal policy, economic indicators, financial reporting, quantitative methods, and basic risk concepts.',
    weight: '5 questions, 5%',
  },
  {
    topic: 'Investment Vehicle Characteristics',
    description:
      'The characteristics of different types of investment vehicles. Topics include cash and equivalents, fixed income securities and valuations, equities and equity valuation, pooled investments, derivative securities, and insurance-based products.',
    weight: '20 questions, 20%',
  },
  {
    topic: 'Client/Customer Investment Recommendations and Strategies',
    description:
      'Developing a client portfolio, portfolio theory, and suitability. Topics include types of clients; client profiling, capital market theory; portfolio management; tax considerations; retirement planning; special accounts; trading securities; and performance measurement.',
    weight: '30 questions, 30%',
  },
  {
    topic: 'Laws, Regulations, and Guidelines',
    description:
      'The state and federal securities acts and laws, rules, and regulations regarding investment advice. Topics include state and federal securities acts; rules and regulations for investment advisers; ethical practices; and fiduciary obligations.',
    weight: '45 questions, 45%',
  },
];

class Overview extends Component {
  render() {
    const { currentUser, product, inflatedContent } = this.props;

    return (
      <div className={sharedStyles.layout}>
        <div className={sharedStyles.title}>
          Uniform Combined State Law Exam{' '}
          <span className={sharedStyles.shortTitle}>(FINRA Series 66)</span>
        </div>
        <div className={sharedStyles.explanation}>
          <div className={sharedStyles.blurb}>
            The Series 66 exam - the Uniform Combined State Law Examination - is designed
            to test an individual&apos;s knowledge and ability to advise clients in the
            area of investing and how to solicit the purchase or sale of securities within
            a given state.
          </div>
          <div className={sharedStyles.facts}>
            <ul>
              <li>
                <em>Time</em> 150 minutes
              </li>
              <li>
                <em>Format</em> 100 multiple choice
              </li>
              <li>
                <em>Passing score</em> 73% (73/100)
              </li>
              <li>
                <em>Exam fee</em> $177
              </li>
              <li>
                <em>Details</em>{' '}
                <a
                  href="https://www.nasaa.org/exams/exam-content-outlines/series-66-exam-content-outline/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  NASAA <i className="fad fa-external-link" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <TextBlock title="Overview">
          <p>
            The Uniform Combined State Law Exam (a.k.a. the Series 66 exam) was created to
            qualify candidates as both securities agents and investment adviser
            representatives. It is considered a combination of the Series 63 and Series
            65. The exam covers topics, both regulatory and strategic, that have been
            determined to be necessary to understand in order to provide investment advice
            to clients, as well as the purchase and sale of securities and state laws
            pertaining to securities.
          </p>

          <p>
            Despite commonly being called the &quot;FINRA Series 66&quot; it is more
            accurately a North American Securities Administrators Association (NASAA) exam
            administered by FINRA.
          </p>
        </TextBlock>

        <TwoColumnTable title="NASAA's exam summary" records={EXAM_SUMMARY} />

        <ContentOutline
          currentUser={currentUser}
          product={product}
          inflatedContent={inflatedContent}
        />

        <TextBlock title="Eligibility and sponsorship">
          <p>
            The Series 66 does not have any prerequisites, and you do not need to be
            employed by or sponsored by a FINRA member firm in order to register for and
            take the exam. However, whether or not you are sponsored will affect what form
            you need to fill out upon registering: if you are sponsored, you need to fill
            out and submit Form U4; if you are not, you need to fill out Form U10. Both
            forms can be found on and submitted electronically on FINRA&apos;s website.
          </p>

          <p>
            While there are no prerequisites for the Series 66, the SIE and Series 7 are
            both corequisites, meaning that all three exams must be completed in order to
            obtain the registration.
          </p>
        </TextBlock>

        <TextBlock title="Administration of the exam">
          <p>
            The Series 66 exam is administered via computer. A tutorial on how to take the
            exam is provided prior to taking the exam.
          </p>

          <p>
            Each candidate’s exam includes 10 additional, unidentified pretest items that
            do not contribute toward the candidate&apos;s score. The pretest items are
            randomly distributed throughout the exam. Therefore, each candidate’s exam
            consists of a total of 110 items (100 scored and 10 unscored).
          </p>

          <p>
            There is no penalty for guessing. Therefore, candidates should attempt to
            answer all items.
          </p>

          <p>Candidates will be allowed 150 minutes to complete the Series 66 exam.</p>

          <p>
            Candidates are not permitted to bring reference materials to their testing
            session. Severe penalties are imposed on candidates who cheat or attempt to
            cheat on FINRA-administered exams.
          </p>
        </TextBlock>

        <TextBlock title="Scoring of the exam">
          <p>
            All candidate test scores are placed on a common scale using a statistical
            adjustment process known as equating. Equating scores to a common scale
            accounts for the slight variations in difficulty that may exist among the
            different sets of exam items that candidates receive. This allows for a fair
            comparison of scores and ensures that every candidate is held to the same
            passing standard regardless of which set of exam items they received.
          </p>
        </TextBlock>
      </div>
    );
  }
}

export default Overview;
